import './WorkersCard.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchCard } from "../../slices/statisticSlice";

import { Box } from "@mui/material";

import { LargeTitle } from "../../common-components/Titles/Titles";
import { CommonTitle } from "../../common-components/Titles/Titles";


const WorkersCard = ({params}) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const cardStatistic = useSelector((state) => state.statistic.cardStatistic);

    useEffect(() => {
        dispatch(fetchCard({token, params}));
    }, [dispatch, token, params]);

    console.log("params", params);
    console.log("typeof params", typeof params);
   
    return (
        <Box className={"workers_card"}>
            <Box className={"workers_card_container"}>
                <Box className={"workers_card_container_count"}>
                    <LargeTitle property={cardStatistic.workers_total}/>
                </Box>
                <Box className={"workers_card_container_description"}>
                    <CommonTitle property={"Всего задействованных работников"}/>
                </Box>
            </Box>
        </Box>
    )
}

export default WorkersCard;